"use strict";

exports.__esModule = true;
exports.DropdownTitle = exports.ArrowIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _caretDown = _interopRequireDefault(require("../glyphs/elements/nav/caret-down"));

var _excluded = ["isOpen"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ArrowIcon = (0, _styledComponents["default"])(function (_ref) {
  var isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_caretDown["default"], props);
}).withConfig({
  displayName: "components__ArrowIcon",
  componentId: "sc-b4nm66-0"
})(["", ";transform:rotate(", "deg);"], (0, _styles.transitionEase)("0.25s", ["transform"]), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? "-180" : "0";
});
exports.ArrowIcon = ArrowIcon;
var TitleText = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "components__TitleText",
  componentId: "sc-b4nm66-1"
})(["white-space:nowrap;"]);
var TitleContainer = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "components__TitleContainer",
  componentId: "sc-b4nm66-2"
})(["", ";&:hover,&:focus{border-color:", ";color:", ";fill:", ";outline:none;}"], (0, _styles.transitionEase)("0.25s", ["color", "border-color", "fill"]), function (props) {
  return (0, _styles.colors)("dark-blue", props);
}, function (props) {
  return (0, _styles.colors)("dark-blue", props);
}, function (props) {
  return (0, _styles.colors)("dark-blue", props);
});
var titleFont = {
  color: "inherit",
  fontSize: 1,
  fontWeight: 2,
  letterSpacing: "0.23px",
  lineHeight: 1,
  mr: 1
};

var DropdownTitle = function DropdownTitle(_ref3) {
  var children = _ref3.children,
      show = _ref3.show;
  return /*#__PURE__*/_react["default"].createElement(TitleContainer, {
    alignItems: "center",
    border: "1px solid",
    borderColor: show ? "dark-blue" : "gray",
    borderRadius: "4px",
    color: show ? "dark-blue" : "text-link",
    fill: show ? "dark-blue" : "text-link",
    justifyContent: "space-between",
    px: 2,
    py: "5px",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(TitleText, titleFont, children), /*#__PURE__*/_react["default"].createElement(ArrowIcon, {
    cursor: "pointer",
    fill: "inherit",
    height: 12,
    isOpen: show,
    width: 12
  }));
};

exports.DropdownTitle = DropdownTitle;
DropdownTitle.propTypes = {
  children: _propTypes.node,
  show: _propTypes.bool
};
DropdownTitle.displayName = "Modules.DropdownTitle";